module.exports = __webpack_public_path__ + "static/spaceKitchenTablet@x2-83b2b15c97d43310c0515d2fc8c8f4af.png";